module.exports = __webpack_public_path__ + "static/media/VirtuOwl_Logo_BrandMark_Pos (5).3d69890d.png";